import { render, staticRenderFns } from "./Transfer_goods_received.vue?vue&type=template&id=50adf112&scoped=true&"
import script from "./Transfer_goods_received.vue?vue&type=script&lang=js&"
export * from "./Transfer_goods_received.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_goods_received.vue?vue&type=style&index=0&id=50adf112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50adf112",
  null
  
)

export default component.exports